<div id="list">

  <app-contact *ngFor="let contact of contacts"
                [contact]="contact"
                (onSelect)="selectContact1(contact)"
  ></app-contact>

</div>
